import React from 'react'

interface ScreenWrapperProps {
  children: React.ReactNode
}

export const ScreenWrapper: React.FC<ScreenWrapperProps> = ({ children }) => {
  return <div className="w-full sm:w-[640px] md:w-[768px] lg:w-[1024px]  mx-auto px-0 sm:px-2 lg:px-4">{children}</div>
}
